import React from 'react';

const BtnLoadingIndicator = ({ className = '', isLoading = true }) => (
  isLoading
    ? <div className={`animate-spin border-b-2 rounded-full h-5 w-5 mr-3 ${className}`} />
    : null
);

export default BtnLoadingIndicator;
